import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "006_resequence_sales_invoice_numbers",
  version: "1.3.2",
  ignoreErrors: ["no such table: accounting_invoices"],
  sql: `
UPDATE \`sales_invoices\`
SET
  \`invoice_no\` = '__INV_RESEQ__' || \`id\`,
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`invoice_type\` = 'sales'
  AND EXISTS (
    SELECT 1
    FROM sqlite_master
    WHERE type = 'table' AND name = 'accounting_invoices'
  );

UPDATE \`accounting_invoices\`
SET
  \`invoice_no\` = '__INV_RESEQ__' || \`id\`,
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (
  SELECT \`id\`
  FROM \`sales_invoices\`
  WHERE \`invoice_type\` = 'sales'
);

WITH numbered AS (
  SELECT
    candidates.\`id\`,
    'INV-' || COALESCE(NULLIF(substr(candidates.\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now')) || '-' || printf(
      '%05d',
      COALESCE(existing_non_target.max_seq, 0) + ROW_NUMBER() OVER (
        PARTITION BY COALESCE(NULLIF(substr(candidates.\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now'))
        ORDER BY candidates.\`invoice_date\`, candidates.\`created_at\`, candidates.\`id\`
      )
    ) AS new_invoice_no
  FROM \`sales_invoices\` candidates
  LEFT JOIN (
    SELECT
      substr(\`invoice_no\`, 5, 4) AS doc_year,
      MAX(CAST(substr(\`invoice_no\`, 10) AS INTEGER)) AS max_seq
    FROM \`accounting_invoices\`
    WHERE \`invoice_no\` GLOB 'INV-[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][0-9]'
      AND \`id\` NOT IN (
        SELECT \`id\`
        FROM \`sales_invoices\`
        WHERE \`invoice_type\` = 'sales'
      )
    GROUP BY substr(\`invoice_no\`, 5, 4)
  ) existing_non_target
    ON existing_non_target.doc_year = COALESCE(NULLIF(substr(candidates.\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now'))
  WHERE candidates.\`invoice_type\` = 'sales'
)
UPDATE \`accounting_invoices\`
SET
  \`invoice_no\` = (SELECT numbered.new_invoice_no FROM numbered WHERE numbered.\`id\` = \`accounting_invoices\`.\`id\`),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (SELECT \`id\` FROM numbered);

WITH numbered AS (
  SELECT
    candidates.\`id\`,
    'INV-' || COALESCE(NULLIF(substr(candidates.\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now')) || '-' || printf(
      '%05d',
      COALESCE(existing_non_target.max_seq, 0) + ROW_NUMBER() OVER (
        PARTITION BY COALESCE(NULLIF(substr(candidates.\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now'))
        ORDER BY candidates.\`invoice_date\`, candidates.\`created_at\`, candidates.\`id\`
      )
    ) AS new_invoice_no
  FROM \`sales_invoices\` candidates
  LEFT JOIN (
    SELECT
      substr(\`invoice_no\`, 5, 4) AS doc_year,
      MAX(CAST(substr(\`invoice_no\`, 10) AS INTEGER)) AS max_seq
    FROM \`accounting_invoices\`
    WHERE \`invoice_no\` GLOB 'INV-[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][0-9]'
      AND \`id\` NOT IN (
        SELECT \`id\`
        FROM \`sales_invoices\`
        WHERE \`invoice_type\` = 'sales'
      )
    GROUP BY substr(\`invoice_no\`, 5, 4)
  ) existing_non_target
    ON existing_non_target.doc_year = COALESCE(NULLIF(substr(candidates.\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now'))
  WHERE candidates.\`invoice_type\` = 'sales'
)
UPDATE \`sales_invoices\`
SET
  \`invoice_no\` = (SELECT numbered.new_invoice_no FROM numbered WHERE numbered.\`id\` = \`sales_invoices\`.\`id\`),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (SELECT \`id\` FROM numbered);

WITH current_year_max AS (
  SELECT COALESCE(MAX(CAST(substr(\`invoice_no\`, 10) AS INTEGER)), 0) AS max_seq
  FROM \`sales_invoices\`
  WHERE \`invoice_type\` = 'sales'
    AND substr(\`invoice_no\`, 5, 4) = strftime('%Y', 'now')
    AND \`invoice_no\` GLOB 'INV-[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][0-9]'
)
UPDATE \`core_numbering_series\`
SET
  \`prefix\` = 'INV-{YYYY}-#####',
  \`current_value\` = (SELECT max_seq FROM current_year_max),
  \`reset_every\` = 'yearly',
  \`last_reset_year\` = CAST(strftime('%Y', 'now') AS INTEGER),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`module\` = 'sales'
  AND \`doctype\` = 'sales_invoice'
  AND \`is_default\` = 1
  AND (SELECT max_seq FROM current_year_max) > 0;
  `.trim(),
};
